<template>
  <viewer v-if="typeof thumb === 'string'" :images="showFull">
    <img :src="thumb" alt="">
  </viewer>
  <viewer v-else :images="showFull">
    <img
      class="img-grid"
      v-for="(img, index) in thumb"
      :key="index"
      :src="img"
      :style="{'background-image': 'url(' + img + ')'}"
    />
  </viewer>
</template>

<script type="text/ecmascript-6">
// 图片查看器
import Vue from 'vue'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)

export default {
  props: {
    full: {
      // type: Array
    },
    thumb: {
      // type: Array
    }
  },
  components: {

  },
  data () {
    return {
      showFull: []
    }
  },
  created () {
    this.setFull()
  },
  methods: {
    setFull () {
      if(typeof this.thumb === 'string'){
        this.showFull.push(this.full)
        Viewer.setDefaults({
          title: 0,
          toolbar: {
            zoomIn: 4,
            zoomOut: 4,
            oneToOne: 4,
            reset: 4,
            prev: 0,
            // play: {
            //   show: 4,
            //   size: 'large',
            // },
            play: 0,
            next: 0,
            rotateLeft: 4,
            rotateRight: 4,
            flipHorizontal: 4,
            flipVertical: 4,
          }
        })
      }else{
        this.showFull = this.full
        Viewer.setDefaults({
          title: 0,
          toolbar: {
            zoomIn: 4,
            zoomOut: 4,
            oneToOne: 4,
            reset: 4,
            prev: 4,
            play: {
              show: 4,
              size: 'large',
            },
            next: 4,
            rotateLeft: 4,
            rotateRight: 4,
            flipHorizontal: 4,
            flipVertical: 4,
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
</style>
